// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Card from "../../library/Card.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as CatalogueModal from "./CatalogueModal.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function CatalogueCard(props) {
  var card = props.card;
  var match = React.useState(function () {
        return false;
      });
  var setModalOpen = match[1];
  var onRequestClose = function (param) {
    Curry._1(setModalOpen, (function (param) {
            return false;
          }));
  };
  var openFunc = function (param) {
    Curry._1(setModalOpen, (function (param) {
            return true;
          }));
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Card.make, {
                      card: card,
                      position: props.position,
                      skuDict: Caml_option.some(Belt_Option.getWithDefault(props.skuDict, {})),
                      onClick: openFunc
                    }, "eGifCard_" + card.uid),
                JsxRuntime.jsx(CatalogueModal.make, {
                      modalOpen: match[0],
                      onRequestClose: onRequestClose
                    })
              ]
            });
}

var SkuPresentation;

var make = CatalogueCard;

export {
  SkuPresentation ,
  make ,
}
/* Card Not a pure module */
